module.exports = __webpack_public_path__ + "static/IBMPlexMono-Bold-0fe304ab4da57c0d18ae803661491d58.woff2";